import clsx from 'clsx';
import React from 'react';
import { bsClass, getClassSet, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class ButtonToolbar extends React.Component {
  render() {
    const {
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = getClassSet(bsProps);
    return /*#__PURE__*/_jsx("div", {
      ...elementProps,
      role: "toolbar",
      className: clsx(className, classes)
    });
  }
}
export default bsClass('btn-toolbar', ButtonToolbar);